import React from 'react';
import { SvgIcon } from 'material-ui';

const ChevronUpIcon = props => (
  <SvgIcon {...props} viewBox='0 0 15 8' style={props.style}>
    <g
      id='Page-1'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      opacity='0.411798007'
    >
      <g
        id='seat_passengers_2-copy-2'
        transform='translate(-239.000000, -312.000000)'
        fill='#9BA1AC'
      >
        <path
          d='M245.349672,316.01311 L250.626768,321.290207 C251.023905,321.687344 251.023905,322.331231 250.626768,322.728368 C250.229631,323.125505 249.585745,323.125505 249.188607,322.728368 L243.297853,316.837613 C243.072434,316.612195 242.974965,316.307278 243.005446,316.01311 C242.974965,315.718943 243.072434,315.414026 243.297853,315.188607 L249.188607,309.297853 C249.585745,308.900716 250.229631,308.900716 250.626768,309.297853 C251.023905,309.69499 251.023905,310.338877 250.626768,310.736014 L245.349672,316.01311 Z'
          id='close'
          transform='translate(246.962311, 316.013110) scale(-1, 1) rotate(-270.000000) translate(-246.962311, -316.013110) '
        />
      </g>
    </g>
  </SvgIcon>
);

export default ChevronUpIcon;



// WEBPACK FOOTER //
// ./src/icons/ChevronUpIcon.js